import React from "react";
import {
  PAGE, TITLE, HR, HR_LIGHT, SH,
  fmtDate, coOwnerLabel, hasParty, attachList,
  Footer,
} from "./printHelpers";

const P2Header = ({ children }) => (
  <div style={{ ...SH, fontStyle: "italic", fontSize: "11px", margin: "10px 0 4px" }}>{children}</div>
);

const PageTwo = ({ form, mode }) => {
  const seller = form?.seller?.owner;
  const vehicle = form?.vehicle;
  const cond = form?.condition;
  const acc = form?.accessories;
  const docs = attachList(form?.attachments);
  const vehicleName = [vehicle?.manufacturer, vehicle?.model || vehicle?.displayName].filter(Boolean).join(" ");

  return (
    <div style={{ ...PAGE, pageBreakBefore: "always" }} data-testid="afsal-print-page-2">
      {mode === "electronic" && <div style={{ height: "60px" }} />}
      <h1 style={TITLE}>ÁSTANDSLÝSING SELJANDA</h1>
      <hr style={HR} />

      {/* SELJANDI | MEÐEIGANDI */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "6px" }}>
        <div>
          <div style={{ ...SH, fontStyle: "italic" }}>SELJANDI</div>
          <div>Kennitala {seller?.kennitala || ""}</div>
          <div>{seller?.name || ""}</div>
          <div style={{ marginTop: "4px" }}>{seller?.address || ""}</div>
          <div>{[seller?.postalCode, seller?.city].filter(Boolean).join(" ")}</div>
          <div>Sími {seller?.phone || ""}</div>
        </div>
        <div>
          <div style={{ ...SH, fontStyle: "italic" }}>{coOwnerLabel(form?.sellerExtraType)}</div>
          {hasParty(form?.seller?.coOwner) ? (
            <>
              <div>Kennitala {form.seller.coOwner.kennitala || ""}</div>
              <div>{form.seller.coOwner.name || ""}</div>
              <div style={{ marginTop: "4px" }}>{form.seller.coOwner.address || ""}</div>
              <div>{[form.seller.coOwner.postalCode, form.seller.coOwner.city].filter(Boolean).join(" ")}</div>
              <div>Sími {form.seller.coOwner.phone || ""}</div>
            </>
          ) : (
            <div>Kennitala</div>
          )}
        </div>
      </div>

      {/* TEGUND OG GERÐ */}
      <P2Header>TEGUND OG GERÐ</P2Header>
      <div style={{ fontWeight: 700 }}>{vehicleName}</div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
        <div>Fast númer {vehicle?.fastanumer || vehicle?.registrationNumber || ""}</div>
        <div>Fyrsti skráningardagur: {fmtDate(vehicle?.firstRegistration)}.</div>
      </div>

      {/* FYLGIHLUTIR */}
      <P2Header>FYLGIHLUTIR</P2Header>
      <div style={{ marginTop: "4px", fontSize: "9px" }}>
        Aðrir fylgihlutir eða nánari lýsing þeirra (listinn er tæmandi og fylgir ökutækinu ekki annað en hér er tekið fram):
      </div>
      <div style={{ marginTop: "2px" }}>{acc?.notes || ""}</div>

      {/* ÁBYRGÐIR */}
      <P2Header>ÁBYRGÐIR</P2Header>
      <div style={{ marginTop: "2px" }}>
        <span style={{ fontSize: "9px" }}>Aðrar ábyrgðir:</span>
      </div>
      <div style={{ minHeight: "10px" }}>{form?.warranties?.otherWarranties || ""}</div>

      {/* MEÐFYLGJANDI GÖGN */}
      <P2Header>MEÐFYLGJANDI GÖGN</P2Header>
      <div style={{ minHeight: "10px", marginTop: "2px" }}>
        {docs.length ? docs.join(", ") : ""}
      </div>

      {/* ÁSTAND ÖKUTÆKIS */}
      <P2Header>ÁSTAND ÖKUTÆKIS</P2Header>
      <div style={{ marginTop: "2px", fontSize: "9.5px", lineHeight: 1.8 }}>
        <div>
          Skipt um tímareim?{"  "}
          {cond?.timingBeltChanged
            ? <>[X] Já eftir {cond?.timingBeltKm || cond?.timingBeltMileage || "______"} km. akstursnotkun{"  "}[ ] Nei{"  "}[ ] Óvitað</>
            : <>[ ] Já eftir ______ km. akstursnotkun{"  "}[X] Nei{"  "}[ ] Óvitað</>
          }
        </div>
        <div>
          Lekur kælivökva{"      "}
          {cond?.coolantLeak ? "[X]" : "[ ]"} Já{"  "}{!cond?.coolantLeak ? "[X]" : "[ ]"} Nei
        </div>
        <div>
          Brennir smurolíu{"    "}
          {cond?.oilBurn ? "[X]" : "[ ]"} Já{"  "}{!cond?.oilBurn ? "[X]" : "[ ]"} Nei
        </div>
        <div>
          Lekur smurolíu{"      "}
          {cond?.oilLeak ? "[X]" : "[ ]"} Já{"  "}{!cond?.oilLeak ? "[X]" : "[ ]"} Nei
        </div>
        <div>
          Bráðabirgðaskráð{"    "}
          {cond?.temporaryRegistered ? "[X]" : "[ ]"} Já{"  "}{!cond?.temporaryRegistered ? "[X]" : "[ ]"} Nei
        </div>
        <div>
          Stórt tjón{"              "}
          {cond?.majorDamage ? "[X]" : "[ ]"} Já{"  "}{!cond?.majorDamage ? "[X]" : "[ ]"} Nei
        </div>
        <div>
          Kaupandi skoðað{"     "}
          {cond?.buyerInspected ? "[X]" : "[ ]"} Já{"  "}{!cond?.buyerInspected ? "[X]" : "[ ]"} Nei
        </div>
        <div style={{ fontStyle: "italic", marginTop: "2px" }}>
          Burðarvirki eða stýrisbúnaður hefur ekki raskast verulega í umferðaróhappi!
        </div>
      </div>
      <div style={{ marginTop: "4px" }}>
        Annað sem ástæða þykir að taka fram um ástand ökutækisins eða ekki kemur fram við venjulega skoðun:
      </div>
      <div style={{ minHeight: "12px" }}>{cond?.conditionComments || ""}</div>

      {/* STAÐFESTING */}
      <div style={{ marginTop: "16px" }}>
        <p style={{ margin: "4px 0", fontSize: "9.5px", fontStyle: "italic" }}>
          Þessi ástandslýsing er gerð þann {fmtDate(form?.general?.afsalDate)}.
        </p>
        <p style={{ margin: "4px 0", fontSize: "9px", lineHeight: 1.4, fontWeight: 700 }}>
          Með undirritun sinni staðfestir seljandi áreiðanleika þessarar ástandslýsingar og ber ábyrgð á að hún sé rétt og ýtarleg.
        </p>
        <p style={{ margin: "4px 0", fontSize: "9px", lineHeight: 1.4, fontWeight: 700 }}>
          Með undirritun sinni staðfestir kaupandi að hann hefur lesið þessa ástandslýsing og gerir engar athugasemdir við hana.
        </p>

        {mode === "handwritten" && (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", marginTop: "12px" }}>
            <div>
              <div style={{ minHeight: "70px" }} />
              <div style={{ borderTop: "2px solid #111", paddingTop: "4px", minHeight: "16px" }}>
                {form?.seller?.owner?.name || "Seljandi"}
              </div>
              <div style={{ fontSize: "8px", color: "#666" }}>Undirskrift seljanda</div>
            </div>
            <div>
              <div style={{ minHeight: "70px" }} />
              <div style={{ borderTop: "2px solid #111", paddingTop: "4px", minHeight: "16px" }}>
                {form?.buyer?.owner?.name || "Kaupandi"}
              </div>
              <div style={{ fontSize: "8px", color: "#666" }}>Undirskrift kaupanda</div>
            </div>
          </div>
        )}
      </div>

      <Footer createdBy={form?.general?.createdBy} refNum={form?.general?.referenceNumber} />
    </div>
  );
};

export default PageTwo;
